// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Q6K7","upload":"Small_upload__2M3G-","imageWrap":"Small_imageWrap__3Qo5W","removeBtn":"Small_removeBtn__3Pchd"};